import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import ViewRendererMixin from '@/helpers/vue_mixins/ViewRendererMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import SubCategoriesGridView from '@/components/v2/ecommerce/CategorySubCategoriesGridView.vue';
import SubCategoriesListView from '@/components/v2/ecommerce/CategorySubCategoriesListView.vue';
let Categories = class Categories extends mixins(ViewRendererMixin) {
    get categoryTemplate() {
        if (this.selectedComponentLayoutOptions.name === 'grid') {
            return SubCategoriesListView;
        }
        return SubCategoriesGridView;
    }
    goToCategoryForm() {
        this.$router.push({ name: 'ecommerce-categories-update', params: { uuid: this.categoryUuid } });
    }
};
__decorate([
    Prop({ type: String, required: true })
], Categories.prototype, "categoryUuid", void 0);
Categories = __decorate([
    Component({
        components: {
            PageTitle,
            BaseSubtitle,
        },
    })
], Categories);
export default Categories;
